export default __webpack_public_path__ + "static/media/D6H.a0b79ca3.jpg";